import { render, staticRenderFns } from "./obtain-en.vue?vue&type=template&id=15f41318&"
import script from "./obtain-en.vue?vue&type=script&lang=js&"
export * from "./obtain-en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports